import type { KeyedMutator } from 'swr';
import type { AppUpdate, AppUpdateLikeResponse } from 'src/types/app-updates/app-update';

import useSWR from 'swr';
import { useMemo } from 'react';

import axiosInstance, { fetcher, endpoints } from 'src/lib/axios';

type UseGetRecentAppUpdatesReturn = {
  updates: AppUpdate[];
  updatesLoading: boolean;
  updatesError: Error | undefined;
  updatesEmpty: boolean;
  updatesRefresh: KeyedMutator<AppUpdate[]>;
  unreadCount: number;
  hasUnread: boolean;
};

export function useGetRecentAppUpdates(limit: number = 5): UseGetRecentAppUpdatesReturn {
  const { data, isLoading, error, mutate } = useSWR<AppUpdate[]>(
    `${endpoints.appUpdates.recent}?limit=${limit}`,
    fetcher
  );

  const unreadCount = useMemo(() => data?.filter((u) => !u.seen).length ?? 0, [data]);

  return {
    updates: data ?? [],
    updatesLoading: isLoading,
    updatesError: error,
    updatesEmpty: !isLoading && !data?.length,
    updatesRefresh: mutate,
    unreadCount,
    hasUnread: unreadCount > 0,
  };
}

export async function markAppUpdateAsSeen(id: number): Promise<void> {
  await axiosInstance.post(endpoints.appUpdates.seen(id));
}

export async function toggleAppUpdateLike(id: number): Promise<AppUpdateLikeResponse> {
  const response = await axiosInstance.post<AppUpdateLikeResponse>(endpoints.appUpdates.like(id));
  return response.data;
}
